import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { RouteConstants } from '../constants/route-constant';
import { useAuth0 } from '@auth0/auth0-react';
import { useDispatch } from 'react-redux';

const Index = () => {
  const { isAuthenticated, isLoading, user } = useAuth0();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    if (isLoading) return;

    // Backend auth now rides the broker-minted Maia JWT (acquired in App.tsx via
    // the token exchange), so there is no Auth0 ID token to stash here — just
    // route based on the Auth0 session.
    if (isAuthenticated && user) {
      navigate(RouteConstants.ROUTE_HOME);
    } else {
      navigate(RouteConstants.ROUTE_LOGIN);
    }
  }, [isAuthenticated, isLoading, user, navigate, dispatch]);

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return null;
};

export default Index;
